<template>
  <div style="padding-top:120px">
    <!-- <img class="banner" src="https://www.xaryxx.com/images/banner/banner6.png" alt=""> -->

    <!-- <img 
    class="banner"
        v-lazy="'https://www.xaryxx.com/images/banner/banner6.png'"> -->


        <!-- <img 
    class="banner"
        v-lazy="'../../../static/banner/1/banner7.jpg'"> -->
        <img class="banner" src="../../assets/banner/newsdetail.jpg" alt="">


    <div class="content" style="flex-direction: column">
      <div class="title">
        {{ detailData.title }}
      </div>
      <div class="date">发布时间：{{ detailData.publishDate }}</div>
      <div class="left-text">
        <p style="text-align:center">
          {{ detailData.introduction }}
        </p>
        <div v-html="detailData.text"></div>



      </div>
    </div>
  </div>
</template>

<script>

import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


import NewsList from "../common/news-list";
import BannerTitle from "../common/banner-title";
import PageItem from "../common/page-item"

import { detail } from "@/api/api";



export default {
  name: "news",
  components: {
    NewsList,
    BannerTitle,
    PageItem,
    quillEditor
  },
  created() {
    let self = this;
    let params = self.$route.query;
    if (params) {
      self.current = params.current || 0
      detail(params.id).then((result) => {

        console.log(result.data, 88888888888)
        self.detailData = result.data
      }).catch((err) => {
        console.log(err);
      })

    }

  },
  data() {
    return {
      detailData: {},
      listData: [],
      navList: [
        { label: "公司动态", value: 0 },
        { label: "行业资讯", value: 1 }
      ],
      current: 0
    };
  },
  methods: {
    // showContent: function(current) {
    //   this.current = current;
    // }
    getNewList(item) {
      this.$router.push({ path: 'newsList', query: { id: item.id, current: this.current } })
    },
  }
};
</script>
<style lang="less" scoped>
/deep/ .left-text img{
  display: block;
  width: 100%;
}
.banner {
  display: block;
  width: 100%;
}

.content {
  width: 74rem;
  padding: 50px 3rem;
  margin: 30px auto;
  // background: #F2F9FB;
  border-radius: 10px 10px 10px 10px;
  min-height: 600px;

  .title {
    font-size: 26px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 30px;
    text-align: center;
  }

  .date {
    padding: 30px 0;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 23px;
    text-align: center;
  }

  p {
    font-weight: bold;
    font-size: 17px;
  }

  .htmls {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
  }



}
</style>



// WEBPACK FOOTER //
// src/components/detail/index.vue